import { defineMessages } from 'react-intl';

export const UsageKeys = Object.freeze({
  RESOURCE_URL: 'USAGE_RESOURCE_URL',
  PROGRESS_TIME: 'USAGE_PROGRESS_TIME',
  TIMESTAMP: 'USAGE_TIMESTAMP',
  TOTAL_LISTENING_TIME: 'USAGE_TOTAL_LISTENING_TIME',
  OVERLAYS: 'USAGE_OVERLAYS',
  SKIP_USAGE: 'SKIP_USAGE',
  CURRENT_RESOURCE_PLAYTIME_START: 'CURRENT_RESOURCE_PLAYTIME_START',
  SESSION_START_TIME: 'SESSION_START_TIME',
} as const);

// These are just the odd child messages that are only tangentially related to playback
// and used by components that really don't need the whole playback domain
export const UsageMessages = defineMessages({
  anonymousTimeoutReached: {
    id: 't.anonymousTimeoutReached',
    defaultMessage: 'Keep the music playing for free.',
  },
} as const);
